import React, { Fragment, useEffect, useState } from "react";
import { StyledAddress, StyledOrderBox, StyledOrderList } from "./styled";
import Address from "../Address";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getEncipherencode } from "utils/encipherencode";
import {
  deliveryStatusCheck,
  ordersList,
  returnRequestsAPI,
  serviceabiltyCheck,
} from "utils/api";
import { useDispatch, useSelector } from "react-redux";
import { getMerchantConfig, getRmsConfig } from "features/config/configSlice";
import {
  addEmail,
  addPhone,
  getEmail,
  getPhone,
} from "features/user/userSlice";
import {
  addOrders,
  getSelectedOrder,
  updateReturnOrder,
  updateSelectedOrder,
} from "features/orders/orderSlice";
import { format } from "date-fns/esm";
import { Button, Skeleton, TextField, Typography } from "@mui/material";
import {
  addRefundJSON,
  addRefundSource,
  addReturnedProducts,
} from "features/returnedProducts/returnedProductSlice";
import {
  addAddress,
  addShipmentMethod,
  updateServiceCheck,
  updateServiceability,
  updateTempServiceability,
} from "features/address/addresSlice";
import { ReactComponent as ChevronRightIcon } from "assets/chevron-right-round.svg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { addUploadMediaIds } from "features/product/productSlice";
import { useTranslation } from "react-i18next";
import LoadingError from "components/v1/common/LoadingError";
import { shouldForwardRequestTarget, versionedPath } from "utils/routes";
import { getApiErrorMessage } from "utils/apiError";
import {
  formatRequestWindow,
  resolveRequestWindows,
} from "utils/requestWindows";
import {
  isSingleRequestPerOrderMerchant,
  singleRequestPerOrderNotice,
} from "utils/merchantPolicies";

function OrdersList({ setLoginLoader }) {
  const { t } = useTranslation();
  // Variables
  const [params] = useSearchParams();
  const encipherencode = getEncipherencode(params);
  // const [moreOrders, setMoreOrders] = useState(false);
  const [allOrders, setAllOrders] = useState({});
  const [returnRequests, setReturnRequests] = useState([]);
  const [currentRequests, setCurrentRequests] = useState([]);
  const merchantConfig = useSelector(getMerchantConfig);
  const rmsConfig = useSelector(getRmsConfig);
  const userPhone = useSelector(getPhone) || params.get("p");
  const userEmail = useSelector(getEmail) || params.get("e");
  const dispatch = useDispatch();
  const selectedOrder = useSelector(getSelectedOrder);
  const [customerName, setCustomerName] = useState("");
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [addressLoader, setAddressLoader] = useState(true);
  const [serviceability, setserviceability] = useState(false);
  const [serviceableCheck, setServiceableCheck] = useState(false);
  const [pincode, setPincode] = useState(null);
  const [serviceableLoader, setServiceableLoader] = useState(false);
  const navigate = useNavigate();
  const [offSet, setOffSet] = useState(0);
  const [apiLoadError, setApiLoadError] = useState(false);
  const [requestClick, setRequestClick] = useState(0);
  const [noMoreRequests, setNoMoreRequests] = useState(0);
  const [viewMoreLoading, setViewMoreLoading] = useState(false);
  const [addressApiLoader, setAddressApiLoader] = useState(false);
  const [tempServiceablity, setTempServiceabilty] = useState(serviceableCheck);
  const [deliveryStatus, setDeliveryStatus] = useState(false);
  const [finishStatus, setfinishStatus] = useState(false);
  const [orderNameInputSearch, setOrderNameInputSearch] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchOrderData, setSearchOrderData] = useState([]);
  const [searchingOrder, setSearchingOrder] = useState(false);
  const orderId = params.get("oid");
  const rid = params.get("rid");
  const nextTarget = params.get("nextTarget");
  const awb = params.get("awb");
  const access_token = params.get("access_token");

  const onBackButtonEvent = (e) => {
    e.preventDefault();
    if (!finishStatus) {
      setfinishStatus(true);
      if (selectedOrder !== null && Object.keys(selectedOrder).length > 0) {
        dispatch(updateSelectedOrder({}));
      } else {
        let url = "/";
        if (encipherencode) {
          url += `?encipherencode=${encipherencode}`;
        }
        navigate(url);
        // sessionIframe removed intentionally; legacy session sync disabled.
        // let iframe = document.getElementById("sessionIframe");
        // iframe?.contentWindow?.postMessage(
        //   { phone: null, email: null, topic: "PRAGMA" },
        //   "*",
        // );
        dispatch(addPhone(null));
        dispatch(addEmail(null));
      }
    }
  };

  // Calling APIs on page load
  useEffect(() => {
    if (
      Object.keys(merchantConfig).length > 0 &&
      (userPhone !== null || userEmail !== null)
    ) {
      if (access_token !== null) {
        sessionStorage.setItem("access_token", access_token);
      }
      if (
        nextTarget &&
        nextTarget === "tracking" &&
        shouldForwardRequestTarget(nextTarget, rid)
      ) {
        navigate(`${versionedPath("/tracking")}?rid=${rid}`);
      } else if (
        nextTarget &&
        nextTarget === "pickup-image-submission" &&
        shouldForwardRequestTarget(nextTarget, rid)
      ) {
        navigate(
          `${versionedPath("/pickup-image-submission")}?rid=${rid}&awb=${awb}`,
        );
      } else {
        ordersList(offSet, undefined, orderId)
          .then((resp) => {
            const orders = resp.data.orders || [];
            setAllOrders(orders);
            dispatch(addOrders(orders));
            setCustomerName(resp.data.customer_name);
            setOrdersLoading(false);
            setApiLoadError(false);
            setLoginLoader(false);
            if (orderId !== null) {
              if (userPhone != null) {
                dispatch(addPhone(userPhone));
              }
              if (userEmail !== null) {
                dispatch(addEmail(userEmail.toLowerCase()));
              }
              let preSelectedOrder = orders[0];
              if (preSelectedOrder && preSelectedOrder !== null) {
                if (preSelectedOrder.eligible || preSelectedOrder.rr_exists) {
                  updateOrderDetails(preSelectedOrder);
                } else {
                  toast.error(t("orders.notEligible"), {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 6000,
                    hideProgressBar: false,
                    closeOnClick: true,
                  });
                }
              } else {
                toast.error(t("orders.notFound"), {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 6000,
                  hideProgressBar: false,
                  closeOnClick: true,
                });
              }
            } else {
              dispatch(updateSelectedOrder({}));
            }
          })
          .catch((err) => {
            if (userPhone === "" && userEmail === "") {
              // sessionIframe removed intentionally; legacy session sync disabled.
              // let iframe = document.getElementById("sessionIframe");
              // iframe.contentWindow.postMessage(
              //   { phone: null, email: null, topic: "PRAGMA" },
              //   "*",
              // );
              let url = "/";
              if (encipherencode) {
                url += `?encipherencode=${encipherencode}`;
              }
              navigate(url);
              dispatch(addPhone(null));
              dispatch(addEmail(null));
            } else {
              // setApiLoadError(true);
              setOrdersLoading(false);
              if (userPhone && userPhone != null) {
                dispatch(addPhone(userPhone));
              }
              if (userEmail && userEmail !== null) {
                dispatch(addPhone(userEmail));
              }
            }
          });
        returnRequestsAPI(offSet)
          .then((resp) => {
            setReturnRequests(resp.data?.requests);
            setCurrentRequests(resp.data?.requests.slice(0, 2));
            setApiLoadError(false);
          })
          .catch((err) => {
            if (userPhone === "" && userEmail === "") {
              // sessionIframe removed intentionally; legacy session sync disabled.
              // let iframe = document.getElementById("sessionIframe");
              // iframe.contentWindow.postMessage(
              //   { phone: null, email: null, topic: "PRAGMA" },
              //   "*",
              // );
              let url = "/";
              if (encipherencode) {
                url += `?encipherencode=${encipherencode}`;
              }
              navigate(url);
              dispatch(addPhone(null));
              dispatch(addEmail(null));
            } else {
              // setApiLoadError(true);
              setOrdersLoading(false);
            }
          });
        window.history.pushState(
          null,
          null,
          encipherencode
            ? `${window.location.pathname}?encipherencode=${encipherencode}`
            : `${window.location.pathname}`,
        );
        window.addEventListener("popstate", onBackButtonEvent);
        return () => {
          window.removeEventListener("popstate", onBackButtonEvent);
        };
      }
    } else {
      if (userPhone == null && userEmail == null) {
        let url = "/";
        if (encipherencode) {
          url += `?encipherencode=${encipherencode}`;
        }
        navigate(url);
      }
    }
    dispatch(addRefundSource(null));
    dispatch(addRefundJSON({}));
  }, [merchantConfig]);

  useEffect(() => {
    dispatch(addUploadMediaIds([]));
    dispatch(addReturnedProducts([]));
  }, []);

  // Handle View more of return requests
  const handleViewMore = () => {
    setRequestClick(requestClick + 1);
    setViewMoreLoading(true);
    if (requestClick > 0) {
      returnRequestsAPI(offSet + 5)
        .then((resp) => {
          // setReturnRequests(resp.data);
          if (resp.data?.requests.length > 0) {
            setCurrentRequests(currentRequests.concat(resp.data?.requests));
            setOffSet(offSet + 5);
            setViewMoreLoading(false);
          } else {
            setNoMoreRequests(true);
            setViewMoreLoading(false);
          }
        })
        .catch((err) => {
          if (userPhone === "" && userEmail === "") {
            let url = "/";
            if (encipherencode) {
              url += `?encipherencode=${encipherencode}`;
            }
            navigate(url);
          }
        });
    } else {
      setCurrentRequests(returnRequests);
      setViewMoreLoading(false);
    }
  };

  // Serviceabilty API Call
  const checkServiceabilty = (pin, edit) => {
    if (!pin) {
      setAddressLoader(false);
      setServiceableLoader(false);
      setAddressApiLoader(false);
      dispatch(updateServiceability(false));
      dispatch(updateServiceCheck(false));
      dispatch(updateTempServiceability(false));
      return;
    }
    serviceabiltyCheck(pin, merchantConfig.merchant_id)
      .then((resp) => {
        setserviceability(resp.data.serviceable);
        dispatch(updateServiceability(resp.data.serviceable));
        if (edit) {
          setTempServiceabilty(resp.data.serviceable);
          dispatch(updateTempServiceability(resp.data.serviceable));
        } else {
          setServiceableCheck(resp.data.serviceable);
          dispatch(updateServiceCheck(resp.data.serviceable));
        }
        setAddressLoader(false);
        setServiceableLoader(false);
        setAddressApiLoader(false);
        if (resp.data.serviceable) {
          dispatch(addShipmentMethod("merchant_handles_return_shipment"));
        } else {
          dispatch(addShipmentMethod("customer_ships_back"));
        }
      })
      .catch((err) => {
        setAddressApiLoader(true);
      });
  };

  // Updating the selected Order details
  const updateOrderDetails = (order) => {
    dispatch(updateSelectedOrder(order));
    dispatch(
      addAddress({
        pincode: order.shipping_address?.zip || order.billing_address?.zip,
        firstName: order.customer_first_name,
        lastName: order.customer_last_name,
        addressLine1:
          order.shipping_address?.address1 || order.billing_address?.address1,
        addressLine2:
          order.shipping_address?.address2 || order.billing_address?.address2,
        state:
          order.shipping_address?.province || order.billing_address?.province,
        city: order.shipping_address?.city || order.billing_address?.city,
        country:
          order.shipping_address?.country || order.billing_address?.country,
      }),
    );
    setPincode(order.shipping_address?.zip || order.billing_address?.zip);
    window.scrollTo(0, 0);
    if (order.delivered_at !== null) {
      setDeliveryStatus(true);
      if (rmsConfig.supports_return_pickup) {
        setAddressLoader(true);
        checkServiceabilty(
          order.shipping_address?.zip || order.billing_address?.zip,
        );
      } else {
        setserviceability(true);
        dispatch(updateServiceability(true));
        setAddressLoader(false);
        setServiceableCheck(false);
        dispatch(updateServiceCheck(false));
        setAddressApiLoader(false);
      }
      let url = versionedPath("/products");
      if (encipherencode) {
        url += `?encipherencode=${encipherencode}`;
      }
      navigate(url);
    } else {
      setAddressLoader(true);
      deliveryStatusCheck(merchantConfig.merchant_id, order.order_id)
        .then((resp) => {
          setDeliveryStatus(true);
          if (rmsConfig.supports_return_pickup) {
            setAddressLoader(true);
            checkServiceabilty(
              order.shipping_address?.zip || order.billing_address?.zip,
            );
          } else {
            setserviceability(true);
            dispatch(updateServiceability(true));
            setAddressLoader(false);
            setServiceableCheck(false);
            dispatch(updateServiceCheck(false));
            setAddressApiLoader(false);
          }
          dispatch(updateSelectedOrder(resp.data.orders[0]));
          let url = versionedPath("/products");
          if (encipherencode) {
            url += `?encipherencode=${encipherencode}`;
          }
          navigate(url);
        })
        .catch((err) => {
          setDeliveryStatus(false);
          setAddressLoader(false);
          toast.error(
            getApiErrorMessage(err, "The order has not been delivered yet."),
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 6000,
              hideProgressBar: false,
              closeOnClick: true,
            },
          );
        });
    }
  };

  // Order Box Strucure
  const OrderBox = ({ order }) => {
    const isOrderActionable =
      order.eligible && !order.is_cancelled && !order.is_rto;
    const isOrderSelectable = isOrderActionable || Boolean(order.rr_exists);
    const windows = resolveRequestWindows({
      subject: order,
      rmsConfig,
      forceExchange: order.force_exchange,
    });
    const exchangeLabel = rmsConfig.only_replacement
      ? "Replacement"
      : "Exchange";
    const windowLines = windows.sameDate
      ? [
          `${exchangeLabel}/Return window is open till ${formatRequestWindow(
            windows.returnDate,
          )}`,
        ]
      : [
          windows.returnDate &&
            `Return window is open till ${formatRequestWindow(
              windows.returnDate,
            )}`,
          windows.exchangeDate &&
            `${exchangeLabel} window is open till ${formatRequestWindow(
              windows.exchangeDate,
            )}`,
        ].filter(Boolean);

    return (
      <StyledOrderBox
        className={
          selectedOrder !== null &&
          selectedOrder?.order_number === order?.order_number &&
          isOrderSelectable
            ? "selected"
            : ""
        }
        primary_color={merchantConfig.primary_theme_color}
        eligible={isOrderSelectable}
        onClick={() => {
          if (isOrderSelectable) {
            updateOrderDetails(order);
          }
        }}
        style={{
          borderRadius: merchantConfig.use_rounded_edge_buttons
            ? "10px"
            : "0px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <span className="order-number">{order.order_name}</span>
          {order.fulfillment_status !== null && (
            <span className="fulfilment-status">
              <span
                style={{
                  background:
                    order.fulfillment_status
                      .toLowerCase()
                      .includes("delivered") &&
                    !order.fulfillment_status.toLowerCase().includes("rto")
                      ? "#DCF6DD"
                      : "#fff8dd",
                  color:
                    order.fulfillment_status
                      .toLowerCase()
                      .includes("delivered") &&
                    !order.fulfillment_status.toLowerCase().includes("rto")
                      ? "#19811C"
                      : "#3B444D",
                  fontWeight: "600",
                  fontSize: "10px",
                  padding: "3px 10px",
                  marginLeft: "10px",
                  borderRadius: merchantConfig.use_rounded_edge_buttons
                    ? "4px"
                    : "0px",
                }}
              >
                {order.fulfillment_status.toLowerCase().includes("delivered") &&
                !order.fulfillment_status.toLowerCase().includes("rto")
                  ? "Delivered"
                  : order.fulfillment_status}
              </span>
              {/* {order.delivered_at !== null && (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#3B444DB2",
                    marginLeft: "10px",
                  }}
                >
                  {format(new Date(order.delivered_at), "dd MMM, yyyy")}
                </span>
              )} */}
            </span>
          )}
          {isOrderSelectable && <KeyboardArrowRightIcon className="right-icon" />}
        </div>
        <div className="order-dates">
          {order.order_created_at && (
            <span className="order-created">
              Placed on{" "}
              {format(new Date(order.order_created_at), "dd MMM, yyyy")},
            </span>
          )}
          {order.delivered_at && (
            <span className="order-delivered">
              Delivered on
              <span style={{ marginLeft: "4px" }}>
                {format(new Date(order.delivered_at), "dd MMM, yyyy")}
              </span>
            </span>
          )}
        </div>
        <div style={{ display: "flex", marginTop: "12px", overflow: "hidden" }}>
          {order.order_items &&
            order.order_items.map((product, i) => {
              return (
                <LazyLoadImage
                  key={i}
                  src={product?.parent_image_url || product.image_url}
                  alt={product.product_title}
                  effect="opacity"
                  style={{
                    marginRight: "10px",
                    height: "100%",
                    maxHeight: "50px",
                    borderRadius: "4px",
                    objectFit: "cover",
                  }}
                />
              );
            })}
        </div>
        {windowLines.map((line) => (
          <p
            key={line}
            style={{
              fontSize: "16px",
              marginTop: "6px",
              marginBottom: "0",
              color: "#3B444D",
            }}
          >
            {line}
          </p>
        ))}
      </StyledOrderBox>
    );
  };

  const handleTracking = (id, reference_id) => {
    dispatch(updateReturnOrder(id));
    let url = versionedPath("/tracking");
    if (encipherencode) {
      url += `?encipherencode=${encipherencode}`;
    }
    navigate(url);
  };

  // Return Box Strucure
  const ReturnBox = ({ returnItem }) => {
    return (
      <div
        className="return-box"
        style={{
          borderRadius: merchantConfig.use_rounded_edge_buttons
            ? "10px"
            : "0px",
        }}
        onClick={() => {
          handleTracking(returnItem.id, returnItem.reference_id);
          dispatch(updateSelectedOrder(returnItem));
        }}
      >
        <div>
          <p className="return-reference-id">#{returnItem.reference_id}</p>
          <p
            className="return-status-label"
            style={{
              borderRadius: merchantConfig.use_rounded_edge_buttons
                ? "10px"
                : "0px",
            }}
          >
            {returnItem.status}
          </p>
        </div>
        <div style={{ marginTop: "5px", overflow: "hidden" }}>
          {returnItem.line_items.map((product, i) => {
            return (
              <LazyLoadImage
                className="return-product-image"
                style={{
                  borderRadius: merchantConfig.use_rounded_edge_buttons
                    ? "4px"
                    : "0px",
                }}
                src={product.variant_image_url}
                effect="opacity"
                alt="preview"
                key={i}
              />
            );
          })}
        </div>
      </div>
    );
  };

  const SkeletonGridBox = () => {
    return (
      <div
        style={{
          marginTop: "20px",
          border: "1px solid  rgba(17, 17, 17, 0.2)",
          padding: "24px",
        }}
      >
        <Typography variant="h4" sx={{ bgColor: "black" }}>
          <Skeleton />
        </Typography>
        <div style={{ display: "flex" }}>
          <Skeleton variant="rounded" height={50} width={50} />
          <Skeleton
            variant="rounded"
            height={50}
            width={50}
            style={{ marginLeft: "10px" }}
            sx={{ bgColor: "black" }}
          />
          <Skeleton
            variant="rounded"
            height={50}
            width={50}
            style={{ marginLeft: "10px" }}
            sx={{ bgColor: "black" }}
          />
        </div>
      </div>
    );
  };

  // Skeleton Loader
  const LoaderGrid = () => {
    return (
      <div className="order-skeleton">
        <Typography variant="h4" sx={{ bgColor: "black" }}>
          <Skeleton />
        </Typography>

        <SkeletonGridBox />
        <SkeletonGridBox />
        <SkeletonGridBox />
      </div>
    );
  };

  return (
    <StyledOrderList
      selectedOrder={
        selectedOrder !== undefined &&
        selectedOrder !== null &&
        selectedOrder.order_number
      }
      primary_color={merchantConfig.primary_theme_color}
    >
      {apiLoadError ? (
        <LoadingError minHeight="80vh" />
      ) : ordersLoading ? (
        <LoaderGrid />
      ) : allOrders.length > 0 ? (
        <Fragment>
          <div className="order-wrapper">
            <p className="customer-name">
              <span>
                Hi{" "}
                <span style={{ textTransform: "capitalize" }}>
                  {customerName}
                </span>
              </span>
            </p>

            {isSingleRequestPerOrderMerchant(merchantConfig.merchant_id) && (
              <p className="single-request-notice">
                {singleRequestPerOrderNotice}
              </p>
            )}

            {/* Return request summary section hidden. Keep this block for easy restore.
              <div
              className="return-container"
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
              }}
            >
              {currentRequests.map((returnItem) => {
                return (
                  <ReturnBox returnItem={returnItem} key={returnItem.id} />
                );
              })}
              </div>

              {returnRequests.length > 0 && !noMoreRequests && (
                <p
                  className="more-orders-mobile"
                  onClick={() => handleViewMore()}
                >
                  View more requests
                </p>
              )}
            */}

            {viewMoreLoading && <LoaderGrid />}

            {allOrders.filter((a) => a.eligible).length > 0 && (
              <div className="select-order-heading">
                <p className="return-for">
                  Select an order to
                  {rmsConfig.only_replacement
                    ? " replace"
                    : rmsConfig.supports_exchange && rmsConfig.supports_refund
                      ? " return or exchange"
                      : rmsConfig.supports_exchange
                        ? " exchange"
                        : " return"}{" "}
                  or track an existing request
                </p>

                {/* Return request desktop "view more" link hidden with summary section.
                  {returnRequests.length > 0 && !noMoreRequests && (
                    <p
                      className="more-orders-web"
                      onClick={() => handleViewMore()}
                    >
                      View more requests
                    </p>
                  )}
                */}
              </div>
            )}

            {allOrders && (
              <Fragment>
                {allOrders
                  .filter((a) => a.eligible && !a.is_cancelled && !a.is_rto)
                  .map((order, i) => {
                    return <OrderBox key={i} order={order} />;
                  })}

                {/* <p
                  className="more-orders"
                  onClick={() => setMoreOrders(!moreOrders)}
                  style={{
                    textDecoration: "underline",
                    color: "var(--color-primary)",
                    fontSize: "14px",
                    cursor: "pointer",
                    width: "fit-content",
                    marginTop: "1rem",
                  }}
                >
                  {!moreOrders ? "View previous orders" : "Show Less"}
                </p> */}

                {/* {moreOrders && ( */}
                <div style={{ marginTop: "10px" }}>
                  {allOrders.filter(
                    (a) => !a.eligible || a.is_cancelled || a.is_rto,
                  ).length > 0 &&
                    rmsConfig.days_to_raise_request_threshold > 0 && (
                      <p className="return-policy">
                        These orders are ineligible for return or exchange. Our
                        return policy lasts{" "}
                        {rmsConfig.days_to_raise_request_threshold} days.
                      </p>
                    )}
                  {allOrders
                    .filter((a) => !a.eligible || a.is_cancelled || a.is_rto)
                    .map((order, i) => {
                      return <OrderBox key={i} order={order} />;
                    })}
                  <p
                    className="retry"
                    style={{
                      color: "var(--color-primary)",
                      margin: "25px 0px 0px",
                      fontSize: "16px",
                    }}
                  >
                    Didn't find the order you were looking for?
                    {/* <span
                      style={{
                        fontWeight: "500",
                        color: "inherit",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        dispatch(addEmail(null));
                        dispatch(addPhone(null));
                        let iframe = document.getElementById("sessionIframe");
                        iframe.contentWindow.postMessage(
                          { phone: null, email: null, topic: "PRAGMA" },
                          "*",
                        );
                        let url = "/";
                        if (encipherencode) {
                          url += `?encipherencode=${encipherencode}`;
                        }
                        navigate(url);
                      }}
                    >
                      {" "}
                      Using different phone/email
                    </span> */}
                  </p>
                  <div
                    className="search-container"
                    style={{ fontSize: "16px", marginTop: "5px" }}
                  >
                    <p style={{ marginTop: "5px" }}>
                      Search here with{" "}
                      <span style={{ fontWeight: "600" }}>
                        {t("orders.searchOrderId")}
                      </span>
                    </p>
                  </div>
                  <div
                    className="search-field"
                    style={{ display: "flex", marginTop: "10px" }}
                  >
                    <TextField
                      name={t("orders.searchOrderId")}
                      label={t("orders.searchOrderId")}
                      value={orderNameInputSearch}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        setOrderNameInputSearch(inputValue);
                      }}
                    />
                    <Button
                      variant="contained"
                      className="search"
                      style={{ display: "flex", margin: "0px 10px" }}
                      disabled={searchingOrder}
                      endIcon={
                        searchingOrder ? (
                          <BeatLoader
                            size={5}
                            color={merchantConfig.secondary_theme_color}
                          />
                        ) : (
                          ""
                        )
                      }
                      onClick={() => {
                        setSearchingOrder(true);
                        ordersList(offSet, orderNameInputSearch).then(
                          (resp) => {
                            setShowSearchResults(true);
                            if (resp.data.orders.length > 0) {
                              setSearchOrderData(resp.data.orders);
                            } else {
                              setSearchOrderData([]);
                            }
                            setSearchingOrder(false);
                            setTimeout(() => {
                              document
                                .getElementById("searchOutput")
                                .scrollIntoView();
                            }, 100);
                          },
                        );
                      }}
                    >
                      {searchingOrder
                        ? `${t("common.loading")}...`
                        : t("common.actions.search")}
                    </Button>
                  </div>
                  {searchingOrder ? (
                    <SkeletonGridBox />
                  ) : (
                    showSearchResults && (
                      <div id="searchOutput" style={{ marginTop: "10px" }}>
                        {searchOrderData.length > 0 ? (
                          searchOrderData.map((order) => {
                            return <OrderBox order={order} />;
                          })
                        ) : (
                          <p>{t("orders.noSearchResults")}</p>
                        )}
                      </div>
                    )
                  )}
                </div>
                {/* )} */}

                <div>
                  <p style={{fontWeight: 400, textDecoration: "none", margin: "1rem 1.25rem"}}>
                    {t("orders.or")}
                  </p>
                  <p className="change-user" onClick={() => navigate(`/?encipherencode=${encipherencode}`)}>
                    {t("orders.changePhoneEmail")}
                  </p>
                </div>

                {/* {merchantConfig.whatsapp_help &&
                  merchantConfig.whatsapp_help !== null && (
                    <a
                      href={merchantConfig.whatsapp_help}
                      target="_blank"
                      rel="noreferrer"
                      className="help"
                      style={{
                        fontWeight: "600",
                        fontSize: "12px",
                        color: "var(--color-primary)",
                        margin: "30px 0px",
                        display: "block",
                      }}
                    >
                      Need Help?
                    </a>
                  )} */}
              </Fragment>
            )}
          </div>

          {/* Address Section  */}

          {selectedOrder &&
            selectedOrder !== null &&
            allOrders &&
            allOrders.filter(
              (a) => a?.order_number === selectedOrder?.order_number,
            ).length > 0 && (
              <StyledAddress>
                <Address
                  allOrders={allOrders}
                  selectedOrder={selectedOrder?.order_number}
                  addressLoader={addressLoader}
                  serviceableCheck={serviceableCheck}
                  setServiceableCheck={setServiceableCheck}
                  serviceability={serviceability}
                  checkServiceabilty={checkServiceabilty}
                  pincode={pincode}
                  setPincode={setPincode}
                  serviceableLoader={serviceableLoader}
                  setServiceableLoader={setServiceableLoader}
                  addressApiLoader={addressApiLoader}
                  tempServiceablity={tempServiceablity}
                  setTempServiceabilty={setTempServiceabilty}
                  deliveryStatus={deliveryStatus}
                />
              </StyledAddress>
            )}
        </Fragment>
      ) : (
        <div
          style={{
            color: "#3B444D",
            textAlign: "center",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "80vh",
            justifyContent: "center",
          }}
        >
          <p style={{ lineHeight: "1.5rem" }}>
            We couldn't find any orders for {userPhone || userEmail}.{" "}
            <a
              href={encipherencode ? `/?encipherencode=${encipherencode}` : "/"}
              style={{
                textDecoration: "underline",
                fontWeight: "600",
                color: "inherit",
              }}
              onClick={() => {
                dispatch(addEmail(null));
                dispatch(addPhone(null));
                // sessionIframe removed intentionally; legacy session sync disabled.
                // let iframe = document.getElementById("sessionIframe");
                // iframe.contentWindow.postMessage(
                //   { phone: null, email: null, topic: "PRAGMA" },
                //   "*",
                // );
                let url = versionedPath("/orders");
                if (encipherencode) {
                  url += `?encipherencode=${encipherencode}`;
                }
                navigate(url);
              }}
            >
              Change {rmsConfig.customer_verification_method === "phone" ? "Phone" : rmsConfig.customer_verification_method === "email" ? "Email" : "Email or Phone"}
            </a>
          </p>
          {/* {merchantConfig.whatsapp_help &&
            merchantConfig.whatsapp_help !== null && (
              <a
                href={merchantConfig.whatsapp_help}
                target="_blank"
                rel="noreferrer"
                style={{ marginTop: "30px", display: "block" }}
              >
                Need Help?
              </a>
            )} */}
        </div>
      )}
    </StyledOrderList>
  );
}

export default OrdersList;
